import { render, staticRenderFns } from "./JobPreviewProvisionListLink.vue?vue&type=template&id=24ca207e"
import script from "./JobPreviewProvisionListLink.vue?vue&type=script&lang=js"
export * from "./JobPreviewProvisionListLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports